var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
/**
 * Get the list of available file sources from the server that can be browsed.
 * @param options The options to filter the file sources.
 * @returns The list of available (browsable) file sources from the server.
 */
export function fetchFileSources(options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/remote_files/plugins", {
            params: {
                query: {
                    browsable_only: true,
                    include_kind: options.include,
                    exclude_kind: options.exclude,
                },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        // Since we specified browsable_only in the query, we can safely cast the data to the expected type.
        return data;
    });
}
/**
 * Get the list of files and directories from the server for the given file source URI.
 * @param uri The file source URI to browse.
 * @param isRecursive Whether to recursively retrieve all files inside subdirectories.
 * @param writeable Whether to return only entries that can be written to.
 * @param limit The maximum number of entries to return.
 * @param offset The number of entries to skip before returning the rest.
 * @param query The query string to filter the entries.
 * @param sortBy The field to sort the entries by.
 * @returns The list of files and directories from the server for the given URI.
 */
export function browseRemoteFiles(uri, isRecursive = false, writeable = false, limit, offset, query, sortBy) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { response, data, error } = yield GalaxyApi().GET("/api/remote_files", {
            params: {
                query: {
                    format: "uri",
                    target: uri,
                    recursive: isRecursive,
                    writeable,
                    limit,
                    offset,
                    query,
                    sort_by: sortBy,
                },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        const totalMatches = parseInt((_a = response.headers.get("total_matches")) !== null && _a !== void 0 ? _a : "0");
        // Since we specified format=uri in the query, we can safely cast the data to the expected type.
        const entries = data;
        return { entries, totalMatches };
    });
}
